<template>
  <div class="sign-up">
    <div class="content">
      <div class="el-icon-close fs-22 cursor flex-end marginB10 gray" @click="close"></div>
      <div class="flex-start-between">
        <div>
          <h2 class="fs-24 marginB26">Get started for free today</h2>
          <p class="gray">No credit card required</p>
          <p class="gray marginB33">Gain access to most TVU services</p>
        </div>
        <div
            class="sign-btn"
            @click="toSignIn">Sign In</div>
      </div>
      <el-form
          :model="signForm"
          :rules="rules"
          ref="signForm">
        <el-form-item prop="userName">
          <el-input
              prefix-icon="iconfont icon-name fs-18"
              tabindex='1'
              v-model="signForm.userName"
              @keyup.enter.native="signUp"
              autocomplete="off"
              type="text"
              maxlength="32"
              placeholder="Name"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input
              prefix-icon="iconfont icon-Mail fs-20"
              tabindex='2'
              v-model="signForm.email"
              autocomplete="off"
              type="text"
              maxlength="32"
              @keyup.enter.native="signUp"
              placeholder="Signup with Email"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
              prefix-icon="iconfont icon-Lock fs-22"
              tabindex='3'
              autocomplete="new-password"
              type="password"
              v-model="signForm.password"
              show-password
              @keyup.enter.native="signUp"
              placeholder="Password 8+ characters"></el-input>
        </el-form-item>
      </el-form>
      <div class="fs-12 gray agree-info">
        <el-checkbox v-model="checked"></el-checkbox>
        <span class="agree-des">I agree to TVU Networks </span>
        <span
            class="border cursor"
            @click="jumpToPolicy(2)">Terms</span>
        <span class="agree-and">and</span>
        <span
            class="border cursor"
            @click="jumpToPolicy(1)">Privacy Policy</span>
      </div>
      <div
          class="marginB15">
        <el-button
            @click="signUp"
            class="sign-submit-btn"
            :disabled='isDisabled'
            :loading="isLoading">Get started now</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
const sha512 = require('js-sha512')

export default {
  name: 'SignUpPage',
  data () {
    return {
      signForm: {
        userName: '',
        email: '',
        password: '',
        activityCode:'357306',
        service: 1
      },
      checked: false,
      isDisabled: true,
      isLoading: false
    }
  },
  computed: {
    rules () {
      return {
        userName: [
          { required: true, message: 'Please enter name', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Please enter email', trigger: 'blur' },
          { pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: 'Please enter correct email format', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter valid password', trigger: 'blur' },
          { pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、])[\da-zA-Z`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]{8,64}$/, message: 'Passwords must contain alphabet upper and lower characters, numbers,symbols,and at least 8 digits', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'signForm.userName': function (newVal) {
      if (!newVal || !this.signForm.password || !this.signForm.email) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    'signForm.password': function (newVal) {
      if (!newVal || !this.signForm.userName || !this.signForm.email) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    'signForm.email': function (newVal) {
      if ($('.emailArea').hasClass('errorInput')) {
        $('.emailArea').removeClass('errorInput')
      }
      if (!newVal || !this.signForm.userName || !this.signForm.password) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    }
  },
  methods: {
    close () {
      this.$router.push('/start')
    },
    jumpToPolicy (type) {
      if (type == 1) {
        window.open('https://www.tvunetworks.com/company-privacy-notice/', '_blank')
      } else {
        window.open('https://www.tvunetworks.com/company-terms-and-conditions/', '_blank')
      }
    },
    toSignIn () {
      gaAnalyze('lpSignIn');
      window.location.href = "https://" + window.location.host + '/userGroup/user-group/rgUser/redirectSignIn?service=1';
    },
    signUp () {
      if (!this.checked) {
        return this.$message.error('Please check the service agreement')
      }
      this.isDisabled = false
      this.$refs.signForm.validate((valid) => {
        if (!valid) {
          return
        }
        let params = { ...this.signForm }
        params.password = sha512(this.signForm.password)
        this.isLoading = true
        this.axios.post(
          '/userGroup/user-group/rgUser/register', params).then((res) => {
            if(res.data.errorCode == '80930906' || res.data.errorCode == '80930902'){
              // this.$store.state.userId = res.data.result ? res.data.result.id : '';
              // this.$store.state.email = this.signForm.email;
              this.$store.commit('setUserId', res.data.result ? res.data.result.id : '')
              this.$store.commit('setAccount', this.signForm.email)
              this.$router.push({name:'verify'})
            }else{
              this.$message.error(res.data.errorInfo)
            }
            this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-checkbox {
  margin-right: 0;
}
.agree-info {
  margin: 40px 0 33px;
  .agree-des {
    margin-left: 6px;
  }

  .agree-and {
    margin: 0 5px;
  }
}
</style>
